/** @format */

import {VariantType} from '../model/types';

const getColor = (variant: VariantType, defaultColor: string): string => {
  switch (variant) {
    case 'yellow':
      return '#AA8258';
    case 'red':
      return '#AE5658';
    default:
      return defaultColor;
  }
};

export {getColor};
